import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeviceVariantListFragment = { __typename?: 'DeviceVariant', name: string, domain?: { __typename?: 'Domain', name: string } | null };

export type SaveDeviceVariantMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name: Types.Scalars['String']['input'];
}>;


export type SaveDeviceVariantMutation = { __typename?: 'Mutation', saveDeviceVariant: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', type: string, context?: string | null, location: Array<string> }> | null } };

export type DomainIdByNameQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DomainIdByNameQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', id: number, name: string } | null> } | null };

export type DeleteDeviceVariantMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteDeviceVariantMutation = { __typename?: 'Mutation', deleteDeviceVariant: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> };

export const DeviceVariantListFragmentDoc = gql`
    fragment DeviceVariantList on DeviceVariant {
  name
  domain {
    name
  }
}
    `;
export const SaveDeviceVariantDocument = gql`
    mutation SaveDeviceVariant($id: Int, $domainId: Int, $name: String!) {
  saveDeviceVariant(id: $id, name: $name, domainId: $domainId) {
    id
    errors {
      type
      context
      location
    }
  }
}
    `;
export type SaveDeviceVariantMutationFn = Apollo.MutationFunction<SaveDeviceVariantMutation, SaveDeviceVariantMutationVariables>;

/**
 * __useSaveDeviceVariantMutation__
 *
 * To run a mutation, you first call `useSaveDeviceVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDeviceVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDeviceVariantMutation, { data, loading, error }] = useSaveDeviceVariantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      domainId: // value for 'domainId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSaveDeviceVariantMutation(baseOptions?: Apollo.MutationHookOptions<SaveDeviceVariantMutation, SaveDeviceVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDeviceVariantMutation, SaveDeviceVariantMutationVariables>(SaveDeviceVariantDocument, options);
      }
export type SaveDeviceVariantMutationHookResult = ReturnType<typeof useSaveDeviceVariantMutation>;
export type SaveDeviceVariantMutationResult = Apollo.MutationResult<SaveDeviceVariantMutation>;
export type SaveDeviceVariantMutationOptions = Apollo.BaseMutationOptions<SaveDeviceVariantMutation, SaveDeviceVariantMutationVariables>;
export const DomainIdByNameDocument = gql`
    query DomainIdByName($name: String) {
  domains(filter: $name, order: ["name"]) {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useDomainIdByNameQuery__
 *
 * To run a query within a React component, call `useDomainIdByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainIdByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainIdByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDomainIdByNameQuery(baseOptions?: Apollo.QueryHookOptions<DomainIdByNameQuery, DomainIdByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainIdByNameQuery, DomainIdByNameQueryVariables>(DomainIdByNameDocument, options);
      }
export function useDomainIdByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainIdByNameQuery, DomainIdByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainIdByNameQuery, DomainIdByNameQueryVariables>(DomainIdByNameDocument, options);
        }
export function useDomainIdByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainIdByNameQuery, DomainIdByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainIdByNameQuery, DomainIdByNameQueryVariables>(DomainIdByNameDocument, options);
        }
export type DomainIdByNameQueryHookResult = ReturnType<typeof useDomainIdByNameQuery>;
export type DomainIdByNameLazyQueryHookResult = ReturnType<typeof useDomainIdByNameLazyQuery>;
export type DomainIdByNameSuspenseQueryHookResult = ReturnType<typeof useDomainIdByNameSuspenseQuery>;
export type DomainIdByNameQueryResult = Apollo.QueryResult<DomainIdByNameQuery, DomainIdByNameQueryVariables>;
export const DeleteDeviceVariantDocument = gql`
    mutation DeleteDeviceVariant($id: Int!) {
  deleteDeviceVariant(id: $id) {
    location
    context
    type
  }
}
    `;
export type DeleteDeviceVariantMutationFn = Apollo.MutationFunction<DeleteDeviceVariantMutation, DeleteDeviceVariantMutationVariables>;

/**
 * __useDeleteDeviceVariantMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceVariantMutation, { data, loading, error }] = useDeleteDeviceVariantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceVariantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceVariantMutation, DeleteDeviceVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceVariantMutation, DeleteDeviceVariantMutationVariables>(DeleteDeviceVariantDocument, options);
      }
export type DeleteDeviceVariantMutationHookResult = ReturnType<typeof useDeleteDeviceVariantMutation>;
export type DeleteDeviceVariantMutationResult = Apollo.MutationResult<DeleteDeviceVariantMutation>;
export type DeleteDeviceVariantMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceVariantMutation, DeleteDeviceVariantMutationVariables>;